"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon element-board", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { fill: "#C7C7C7", width: "38", height: "38", rx: "4" }),
            _react2.default.createElement("path", { d: "M1 3.995v30.01A2.99 2.99 0 0 0 3.995 37h30.01A2.99 2.99 0 0 0 37 34.005V3.995A2.99 2.99 0 0 0 34.005 1H3.995A2.99 2.99 0 0 0 1 3.995zm-1 0A3.99 3.99 0 0 1 3.995 0h30.01A3.99 3.99 0 0 1 38 3.995v30.01A3.99 3.99 0 0 1 34.005 38H3.995A3.99 3.99 0 0 1 0 34.005V3.995z", fill: "#A5A5A5" }),
            _react2.default.createElement("path", { fill: "#FFF", d: "M9 9h9v12H9zM9 23h9v6H9zM20 9h9v20h-9z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/element-board.js
// module id = 1793
// module chunks = 0